import type { RequestInterface } from '~/common/types';
import type { Form, FormBuilderFormID } from '~/forms/types';

export class FormsListRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/forms-list';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class TopSubmittedFormsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/submitted-forms/top-submitted-forms';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetFormInputsRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    formID,
    params,
  }: {
    token: string;
    formID: Form['formID'];
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/forms/${formID}/inputs`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetFormBuilderFormRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    id,
    params,
  }: {
    token: string;
    id: FormBuilderFormID;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/form-builder/${id}`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class CorrectiveActionsSubmittedForms implements RequestInterface {
  method = 'get';
  path = '/api/v1/submitted-forms/corrective-actions';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}
